import { render, staticRenderFns } from "./DatasetLayerSelector.vue?vue&type=template&id=24da4bf1&"
import script from "./DatasetLayerSelector.vue?vue&type=script&lang=js&"
export * from "./DatasetLayerSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports